module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-170.b9a67187.webp";